import {
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useCardForTableStyles from 'app/tss/cardForTable'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import useTableStyles from 'app/tss/table.styles'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import getConfig from './containersDamaged.config'

const ContainersDamaged = ({
    serviceCenterId,
}: { serviceCenterId: number }) => {
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()

    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const tableConfig = useMemo(() => {
        return getConfig({
            containersLinkConfig: {
                path: ContainersRoutes.Overview.path,
                params: {
                    key: 'serialNumber',
                },
            },
        })
    }, []) // eslint-disable-line

    return (
        <Card
            className={cardClasses.root}
            title="Containers Damaged"
        >
            <SkyNetTable
                name="ContainersDamaged"
                tableConfig={tableConfig}
                customUrl={requestConfig.containersDamaged({
                    serviceCenterId,
                }).url}
                className={tableClasses.table}
                simple
            />
        </Card>
    )
}

export default ContainersDamaged
